import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import "../../styles/layouts/global-layout.scss";
import { ToastService } from "@/shared/services/toast-popup-services";
import CustomToast from "@/shared/hooks/custom-toast";

export default function DefaultLayout({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const { success, error, warning, info } = CustomToast();

  useEffect(() => {
    ToastService.init({
      success,
      error,
      warning,
      info,
    });
    const language = localStorage.getItem("language");
    if (language) {
      i18n.changeLanguage(language);
    } else {
      i18n.changeLanguage("en");
    }
  }, [i18n.language]);

  // useEffect(() => {
  //   if (import.meta.env.VITE_NODE_ENV === "development") return;

  //   const script = document.createElement("script");
  //   script.src = "/newrelic.js";
  //   script.type = "text/javascript";
  //   document.head.appendChild(script);
  // }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      {children}
    </>
  );
}
